// extracted by css-extract-rspack-plugin
var _1 = "AUa4sqN_ij8RKPJh";
var _2 = "KYovQDgtvYUp1gTa";
var _3 = "_pXhICNxMOkuat_p";
var _4 = "_pXhICNxMOkuat_p";
var _5 = "aYxHaV44fkBrulPd";
var _6 = "aYxHaV44fkBrulPd";
var _7 = "Fyu4ggycUBYLJ2GB";
var _8 = "Fyu4ggycUBYLJ2GB";
export { _1 as "divider", _2 as "header", _3 as "header--sticky", _4 as "headerSticky", _5 as "is-sticky", _6 as "isSticky", _7 as "tabs-container", _8 as "tabsContainer" }
